import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";
import {formatUtcToDate} from "../../Helpers/DateHelper";
const UnfiscalInvoicesTotal = () => {
  const [totalUnfiscal, setTotalUnfiscal] = useState(300);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNum, setIsLoadingNum] = useState(false);
  const currentDate = new Date();
  
  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/notFiscalInvoices?tenantId=${localStorage.getItem("tenantId")}`, config)
      .then((result) => {
        setTotalUnfiscal(result.data.totalNumber);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-user">
            <div className="dashboard-card-body-user-image">
              <span className="icon icon-substitution" style={{ fontSize: 40 }}></span>
            </div>
            <div className="dashboard-card-body-user-simpleData">
              {isLoadingNum ? <WhiteLoader /> : totalUnfiscal}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-user">
            {translator("Dashboard-TotalNumberOfUnfiscal-Title")} <br/>
            na dan  <br/>
 {formatUtcToDate(currentDate.toString())}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default UnfiscalInvoicesTotal;
